import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';
import { useUIStore } from '@/store/uiStore';

export function AuthLanguageButton() {
  const { t } = useTranslation();
  const { language, enabledLanguages, setLanguage } = useUIStore();
  const nextLanguage = enabledLanguages.find(item => item !== language);
  if (!nextLanguage) return null;
  return <div className="mb-6 flex justify-end">
    <Button type="button" variant="outline" size="sm" className="gap-2"
      onClick={() => setLanguage(nextLanguage)}
      aria-label={t('layout.header.switchLanguage', { language: t(`common.languages.${nextLanguage}`) })}>
      <Languages className="h-4 w-4" aria-hidden="true" />
      {t(`common.languageShort.${nextLanguage}`)}
    </Button>
  </div>;
}
